export default __webpack_public_path__ + "static/media/017-cow.85a7bfc8.svg";